import CoordinatorTournamentSelect from './CoordinatorTournamentSelect';

export default CoordinatorTournamentSelect;
